import React from 'react';
import '@radnuc/react-ui-components/dist/ExpertSettingsDisplay.css'

import { ExpertSettingsDisplayInterface,
         AllAlertsCollapseSetting, AllAlertsDismissSetting,
         RefreshPageSetting, SettingsComponentDisplay,
         ExpertSettingsButtonState } from '@radnuc/react-ui-components/dist/ExpertSettingsDisplay';
import { InvestigationInterface } from '@radnuc/react-ui-components/dist/InvestigationDisplay';
import { AuthenticationInterface } from '@radnuc/react-ui-components';


interface ExpertSettingsButtonProps {
    investigationInterface?: InvestigationInterface,
    suppressedAlertsInterface?: SuppressedAlertsInterface,
    uiVersionString?: string,
 }

interface ExpertSettingsDisplayProps {
    menuOpen: boolean,
    alertAcknowledge?: boolean,
    expertSettingsDisplayInterface: ExpertSettingsDisplayInterface,
    suppressedAlertsInterface?: SuppressedAlertsInterface,
    investigationInterface?: InvestigationInterface,
    uiVersionString?: string,
}

export class BD21ExpertSettingsDisplay extends React.Component<ExpertSettingsDisplayProps> {
    constructor(props: ExpertSettingsDisplayProps) {
        super(props)
        this.handleMenuCloseButtonClick = this.handleMenuCloseButtonClick.bind(this);

    }
    handleMenuCloseButtonClick() {
        this.props.expertSettingsDisplayInterface.close();
    }

    render() {
        var sidenavClassName = "sidenav";
        if (this.props.menuOpen) {
            sidenavClassName += " open"
        }

        let classNameSuppressedAlertsMenu = "suppressed-alerts-menu";
        if( this.props.suppressedAlertsInterface?.showSuppressedAlerts !== true ){
            classNameSuppressedAlertsMenu += " hidden";
        }
        const showSuppressedAlertsSettings =
                <div id={'suppressed-alerts-menu'} className={classNameSuppressedAlertsMenu}>
                    <SuppressedAlertsSetting suppressedAlertsInterface={this.props.suppressedAlertsInterface}/>
                </div>

        const alertsSettings =
            <div>
                <AllAlertsCollapseSetting />
                <AllAlertsDismissSetting investigationInterface={this.props.investigationInterface}/>
                {showSuppressedAlertsSettings}
                <br></br>
            </div>

        let uiVersionDisplay;
        if(this.props.uiVersionString !== undefined){
            const uiVersionString = "UI Version: "+this.props.uiVersionString;
            uiVersionDisplay =
                <label className="status-metric-title" style={{whiteSpace:'nowrap',padding:'10px',fontSize:'0.8em'}}>
                    {uiVersionString}
                </label>
        }
        const managementSettings =
            <div>
                <RefreshPageSetting/>
                <br></br><br></br>
                {uiVersionDisplay}
            </div>


        const settingsContainer =
            <div id="expert-settings-container" className={sidenavClassName}>
                <div className="sidenav-menu" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="status-metric-container">
                        <label className="status-metric-title-big">Expert Settings</label>
                    </div>
                    <div className="closebtn" style={{ cursor: 'pointer' }} onClick={this.handleMenuCloseButtonClick}>&times;</div>
                </div>
                <div className="sidenav-container">
                    <SettingsComponentDisplay title={"Alerts"} content={alertsSettings} />
                    <SettingsComponentDisplay title={"Management"} content={managementSettings} />
                </div>
            </div>

        return (
            <>
                {settingsContainer}
            </>
        )
    }
}

export class BD21ExpertSettingsButton extends React.Component<ExpertSettingsButtonProps, ExpertSettingsButtonState> {
    constructor(props: ExpertSettingsButtonProps) {
        super(props)
        this.state = {
            menuOpen: false
        }
    }

    handleButtonClick(flag: boolean) {
        this.setState(() => ({
            menuOpen: flag
        }));
    }

    render() {
        const expertSettingsDisplayInterface = {
            open: () => this.setState({ menuOpen: true }),
            close: () => this.setState({ menuOpen: false })
        }

        return (
            <>
                <div className={"metric-container"} style={{ cursor: 'pointer' }}
                        onClick={() => { this.handleButtonClick(true) }}>
                    <label className={"metric-title"}>Expert Settings</label>
                </div>
                <BD21ExpertSettingsDisplay menuOpen={this.state.menuOpen}
                    investigationInterface={this.props.investigationInterface}
                    expertSettingsDisplayInterface={expertSettingsDisplayInterface}
                    suppressedAlertsInterface={this.props.suppressedAlertsInterface}
                    uiVersionString={this.props.uiVersionString}/>
            </>
        )
    }
}

//******************************************************************************
//Suppressed Alerts settings
export interface SuppressedAlertsInterface {showSuppressedAlerts: boolean, setShowSuppressedAlerts: (flag:boolean)=> void,}
export interface SuppressedAlertsSettingProps {
    suppressedAlertsInterface?: SuppressedAlertsInterface,
    authenticationInterface?: AuthenticationInterface}
export class SuppressedAlertsSetting extends React.Component<SuppressedAlertsSettingProps> {

    render() {
        let showSuppressedAlertOnClass;
        let showSuppressedAlertOffClass
        if (this.props.suppressedAlertsInterface?.showSuppressedAlerts === true) {
            showSuppressedAlertOnClass = 'selected';
        } else {//if (this.props.showSuppressedAlerts === false) {
            showSuppressedAlertOffClass = 'selected';
        }

        const onClickShowSuppressedAlertOnClass = (flag:boolean) => {
            if(this.props.suppressedAlertsInterface?.showSuppressedAlerts !== flag){
                if(this.props.authenticationInterface){
                    this.props.authenticationInterface.authenticate(()=>this.props.suppressedAlertsInterface?.setShowSuppressedAlerts(flag));
                } else {
                    this.props.suppressedAlertsInterface?.setShowSuppressedAlerts(flag);
                }
            }
        }
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">Show Suppressed Alerts</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div className={"round-skinny-button "+showSuppressedAlertOnClass}
                        onClick={() => onClickShowSuppressedAlertOnClass(true)}>On</div>
                    <div className={"round-skinny-button "+showSuppressedAlertOffClass}
                        onClick={() => onClickShowSuppressedAlertOnClass(false)}>Off</div>
                </div>
            </div>
        )
    }
}
